import React from 'react'
import { Node } from 'reactflow'
import { BaseNodeData } from '../../base/types'
import { NodeTypes } from '../../../../../../shared/models/rule-node'
import { FormProvider, useForm } from 'react-hook-form'
import { Col, Form, Row } from 'react-bootstrap'
import Input from '../../../../../../components/form/Input'
import 'ace-builds/src-noconflict/mode-golang'
import 'ace-builds/src-noconflict/theme-monokai'
import 'ace-builds/src-noconflict/ext-language_tools'

interface ExternalSendEmailConfiguration {
  patternTo: string
  patternCc: string
  patternBcc: string
  subject: string
  bodyTemplate: string
  isHtml: boolean
}

interface ExternalSendEmailFormProps {
  onSubmit: (
    data: Node<
      BaseNodeData<ExternalSendEmailConfiguration>,
      NodeTypes.EXTERNAL_SEND_EMAIL
    >
  ) => void
  defaultValues?: Node<
    BaseNodeData<ExternalSendEmailConfiguration>,
    NodeTypes.EXTERNAL_SEND_EMAIL
  >
}

const TransformToEmailForm = ({
  onSubmit,
  defaultValues,
}: ExternalSendEmailFormProps) => {
  const form = useForm<
    Node<
      BaseNodeData<ExternalSendEmailConfiguration>,
      NodeTypes.EXTERNAL_SEND_EMAIL
    >
  >({
    defaultValues,
  })
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = form

  return (
    <FormProvider {...form}>
      <Form noValidate onSubmit={handleSubmit(onSubmit)} id={'form_rule_node'}>
        <Row className={''}>
          <Form.Group as={Col} lg={6} md={12}>
            <Input
              register={register('data.name', {
                required: 'Le nom est obligatoire',
              })}
              label={'Nom'}
              error={errors?.data?.name}
            />
          </Form.Group>
        </Row>
        <Row className={''}>
          <Form.Group as={Col} lg={6} md={12}>
            <Input
              register={register('data.configuration.patternTo', {
                required: 'Un destinataire est nécessaire',
              })}
              label={'Destinataire'}
              error={errors?.data?.configuration?.patternTo}
            />
          </Form.Group>
        </Row>
        <Row className={''}>
          <Form.Group as={Col} lg={6} md={12}>
            <Input
              register={register('data.configuration.patternCc')}
              label={'Copie'}
              error={errors?.data?.configuration?.patternCc}
            />
          </Form.Group>
          <Form.Group as={Col} lg={6} md={12}>
            <Input
              register={register('data.configuration.patternBcc')}
              label={'Copie cachée'}
              error={errors?.data?.configuration?.patternBcc}
            />
          </Form.Group>
        </Row>
        <Row className={''}>
          <Form.Group as={Col} lg={12} md={12}>
            <Input
              register={register('data.configuration.subject')}
              label={'Sujet'}
              error={errors?.data?.configuration?.subject}
            />
          </Form.Group>
        </Row>
        <Form.Group as={Col} lg={6} md={12}>
          <Form.Check
            type="switch"
            label="Contenu HTML"
            {...register('data.configuration.isHtml')}
          />
        </Form.Group>
        <Row className={''}>
          <Form.Group as={Col} lg={12} md={12}>
            <Input
              type={'textarea'}
              textAreaRows={12}
              register={register('data.configuration.bodyTemplate')}
              label={'Corps'}
              error={errors?.data?.configuration?.bodyTemplate}
            />
          </Form.Group>
        </Row>
      </Form>
    </FormProvider>
  )
}

export default TransformToEmailForm
